module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/204-guernsey-8d6dd5ff0ff745f47a8eb5c5d9933876.svg";